const STRIPE_AUD_PREMIUM_MONTH = process.env.REACT_APP_STRIPE_AUD_PLAN_PREMIUM_MONTH;
const STRIPE_AUD_PREMIUM_YEAR = process.env.REACT_APP_STRIPE_AUD_PLAN_PREMIUM_YEAR;
const STRIPE_INR_PREMIUM_MONTH = process.env.REACT_APP_STRIPE_INR_PLAN_PREMIUM_MONTH;
const STRIPE_INR_PREMIUM_YEAR = process.env.REACT_APP_STRIPE_INR_PLAN_PREMIUM_YEAR;
const STRIPE_USD_PREMIUM_MONTH = process.env.REACT_APP_STRIPE_USD_PLAN_PREMIUM_MONTH;
const STRIPE_USD_PREMIUM_YEAR = process.env.REACT_APP_STRIPE_USD_PLAN_PREMIUM_YEAR;
const STRIPE_CAD_PREMIUM_MONTH = process.env.REACT_APP_STRIPE_CAD_PLAN_PREMIUM_MONTH;
const STRIPE_CAD_PREMIUM_YEAR = process.env.REACT_APP_STRIPE_CAD_PLAN_PREMIUM_YEAR;
const STRIPE_GBP_PREMIUM_MONTH = process.env.REACT_APP_STRIPE_GBP_PLAN_PREMIUM_MONTH;
const STRIPE_GBP_PREMIUM_YEAR = process.env.REACT_APP_STRIPE_GBP_PLAN_PREMIUM_YEAR;
const STRIPE_EUR_PREMIUM_MONTH = process.env.REACT_APP_STRIPE_EUR_PLAN_PREMIUM_MONTH;
const STRIPE_EUR_PREMIUM_YEAR = process.env.REACT_APP_STRIPE_EUR_PLAN_PREMIUM_YEAR;
const STRIPE_NZD_PREMIUM_MONTH = process.env.REACT_APP_STRIPE_NZD_PLAN_PREMIUM_MONTH;
const STRIPE_NZD_PREMIUM_YEAR = process.env.REACT_APP_STRIPE_NZD_PLAN_PREMIUM_YEAR;

// Lifetime Promo (AUD) – add more currencies later if needed
const STRIPE_AUD_PREMIUM_LIFETIME = process.env.REACT_APP_STRIPE_AUD_PLAN_PREMIUM_LIFETIME;



const PAYPAL_AUD_PREMIUM_MONTH = process.env.REACT_APP_PAYPAL_AUD_PLAN_PREMIUM_MONTH;
const PAYPAL_AUD_PREMIUM_YEAR = process.env.REACT_APP_PAYPAL_AUD_PLAN_PREMIUM_YEAR;
const PAYPAL_USD_PREMIUM_MONTH = process.env.REACT_APP_PAYPAL_USD_PLAN_PREMIUM_MONTH;
const PAYPAL_USD_PREMIUM_YEAR = process.env.REACT_APP_PAYPAL_USD_PLAN_PREMIUM_YEAR;
const PAYPAL_CAD_PREMIUM_MONTH = process.env.REACT_APP_PAYPAL_CAD_PLAN_PREMIUM_MONTH;
const PAYPAL_CAD_PREMIUM_YEAR = process.env.REACT_APP_PAYPAL_CAD_PLAN_PREMIUM_YEAR;
const PAYPAL_GBP_PREMIUM_MONTH = process.env.REACT_APP_PAYPAL_GBP_PLAN_PREMIUM_MONTH;
const PAYPAL_GBP_PREMIUM_YEAR = process.env.REACT_APP_PAYPAL_GBP_PLAN_PREMIUM_YEAR;
const PAYPAL_EUR_PREMIUM_MONTH = process.env.REACT_APP_PAYPAL_EUR_PLAN_PREMIUM_MONTH;
const PAYPAL_EUR_PREMIUM_YEAR = process.env.REACT_APP_PAYPAL_EUR_PLAN_PREMIUM_YEAR;
const PAYPAL_NZD_PREMIUM_MONTH = process.env.REACT_APP_PAYPAL_NZD_PLAN_PREMIUM_MONTH;
const PAYPAL_NZD_PREMIUM_YEAR = process.env.REACT_APP_PAYPAL_NZD_PLAN_PREMIUM_YEAR;

// Lifetime Promo (AUD) – add more currencies later if needed
const PAYPAL_AUD_PREMIUM_LIFETIME = process.env.REACT_APP_PAYPAL_AUD_PLAN_PREMIUM_LIFETIME;


export {
  STRIPE_AUD_PREMIUM_MONTH,
  STRIPE_AUD_PREMIUM_YEAR,
  STRIPE_INR_PREMIUM_MONTH,
  STRIPE_INR_PREMIUM_YEAR,
  STRIPE_USD_PREMIUM_MONTH,
  STRIPE_USD_PREMIUM_YEAR,
  STRIPE_CAD_PREMIUM_MONTH,
  STRIPE_CAD_PREMIUM_YEAR,
  STRIPE_GBP_PREMIUM_MONTH,
  STRIPE_GBP_PREMIUM_YEAR,
  STRIPE_EUR_PREMIUM_MONTH,
  STRIPE_EUR_PREMIUM_YEAR,
  STRIPE_NZD_PREMIUM_MONTH,
  STRIPE_NZD_PREMIUM_YEAR,
  STRIPE_AUD_PREMIUM_LIFETIME,

  PAYPAL_AUD_PREMIUM_MONTH,
  PAYPAL_AUD_PREMIUM_YEAR,
  PAYPAL_USD_PREMIUM_MONTH,
  PAYPAL_USD_PREMIUM_YEAR,
  PAYPAL_CAD_PREMIUM_MONTH,
  PAYPAL_CAD_PREMIUM_YEAR,
  PAYPAL_GBP_PREMIUM_MONTH,
  PAYPAL_GBP_PREMIUM_YEAR,
  PAYPAL_EUR_PREMIUM_MONTH,
  PAYPAL_EUR_PREMIUM_YEAR,
  PAYPAL_NZD_PREMIUM_MONTH,
  PAYPAL_NZD_PREMIUM_YEAR,
  PAYPAL_AUD_PREMIUM_LIFETIME
};
